import React, { useState } from 'react';
import Tab from './Tab';
import { TabsContainer } from './styles';

const Tabs = ({ tabs = [], onTabClick = () => {} }) => {
  const [tabSelected, setTabSelected] = useState(tabs.length > 0 ? tabs[0].id : null);

  const handleOnTabClick = id => {
    setTabSelected(id);
    onTabClick(id);
  };

  return (
    <TabsContainer>
      {tabs?.map(t => (
        <Tab
          tabId={t.id}
          isSelected={tabSelected === t.id}
          label={t.label}
          key={t.id}
          handleOnTabClick={() => handleOnTabClick(t.id)}
        />
      ))}
    </TabsContainer>
  );
};

export default Tabs;
